import {createSelector} from "reselect";
import {getPatientsStoreState} from "../../store/patients-selectors";


export const getPatientDevicesStoreState = createSelector(getPatientsStoreState, state => state.devices);
